<template>
<div role="group" aria-labelledby="chart" class="segment">
        <button v-bind:class="{ selected: chartVariable == 'all' }"    v-on:click="chartVariable = 'all'"                                              >All</button>
        <button v-bind:key="variable" v-bind:class="{ selected: chartVariable == variable, [ variable ]: true }" v-on:click="chartVariable = variable" v-for="variable in variableKeys"><span class="bull">&bull;</span>{{ variables[variable].shortName }}</button>
      </div>
      <p class="chart-sub">{{ variables[chartVariable].desc }}</p>
<apexcharts width="103%" height="272" type="line" :options="chartOptions" :series="chartSeries"></apexcharts>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import TransformMonthlyValues from '../util/transform-monthly-values.js'
import toPercentages from '../util/to-percentages.js'

export default {
  name: 'ServiceRidershipChart',
  props: ['agency','baseMonths'],
  data() {
    return {
        chartVariable: 'all'
    }
  },
  mounted() {

  },
  methods: {
    toPercentages: toPercentages.toPercentages,
    chartValuesFoVariable: function(variableName){
      return TransformMonthlyValues.transformedArrayForValue(this.agency.values,variableName,this.startMonth)
    }
  },
  computed: {
      startMonth(){
          return this.baseMonths && this.baseMonths.length > 0 ? this.baseMonths[0] : ''
      },
    variables(){
        var shortName = (this.agency ? this.agency.meta.acronym ? this.agency.meta.acronym : this.agency.meta.friendlyName : '')
        return {
          'vrh': { shortName: 'Service', longName: 'Daily vehicle service hours', desc: 'Average daily number of transit vehicle service hours operated by ' + shortName },
          'upt': { shortName: 'Trips', longName: 'Daily passenger trips', desc: 'Average daily number of transit trips taken by passengers of ' + shortName },
          'all': { desc: 'Percentage of ' + shortName + ' transit service hours delivered, and passenger trips taken, relative to their pre-pandemic levels' }
        }
      },
      variableKeys(){
        return Object.keys(this.variables).filter((key) => { return this.variables[key].shortName })
        },
      chartSeries(){ 
        var result;
        if(this.chartVariable == 'all'){
          result = [
                  { name: this.variables['vrh'].longName, data: this.toPercentages(this.chartValuesFoVariable('vrh'),this.baseMonths) },
                  { name: this.variables['upt'].longName, data: this.toPercentages(this.chartValuesFoVariable('upt'),this.baseMonths) }]
        } else {
          result = [{ name: this.variables[this.chartVariable].longName, data: this.chartValuesFoVariable(this.chartVariable) }]
        }

        var months = this.chartMonths;
        result = result.map((serie) => {
          serie.data = serie.data.map((value,index) => {
            return [months[index],value]
          })

          return serie;
        })

        return result
    },
    chartMonths(){ return TransformMonthlyValues.monthsForValue(this.agency.values,this.chartVariable == 'all' ? 'vrh': this.chartVariable,this.startMonth) },
    chartOptions(){ return {
        chart: {
          id: 'time-chart',
          offsetX: -14,
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false
          },
          selection: {
            enabled: false
          },
          zoom: {
            enabled: false
          },
          fontFamily: 'hero-new, sans-serif'
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: { style: {
            fontWeight: 700,
            cssClass: 'xaxis-labels'
          },
          hideOverlappingLabels: true }
        },
        yaxis: {
          min: 0,
          forceNiceScale: true,
          max: (defaultMax) => {
            return this.chartVariable == 'all' && defaultMax < 1.1 ? 1 : defaultMax
          },
          labels: {
            formatter: (value) => {
              if(this.chartVariable == 'all'){
                return Math.round(value * 100) + "%"
              } else {
                return numberWithCommas(Math.round(value))
              }
            }
          }
        },
        stroke: {
          curve: 'straight',
          width: 4
        },
        markers: {
          size: 5
        },
        legend: {
          show: false
        },
        colors: [(value, seriesIndex, w) => {
          if(this.chartVariable == 'all'){ return '#20ABB5' } else {
            if(this.chartVariable == 'vrh'){ return '#20ABB5' } else {
              return '#BF58BB'
            }
          }
        },'#BF58BB'],
        tooltip: {
          x: {
              show: true,
              format: 'MMM \'yy'
          },
        },
        responsive: [{
          breakpoint: 600,
          options: {
              markers: {
                size: 0
              }
            }
          },
          {
            breakpoint: 400,
            options: {
              chart: {
                height: 180
              },
            }
          }
        ]
      }
      }
  },
  watch: {

  },
  components: {
    apexcharts: VueApexCharts
  }
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
</script>

<style>
div.segment {
  margin-bottom: 8px;
  margin-top: 4px;
}

.segment button {
  display: inline-block;
  height: 36px;
  line-height: 32px;
  border-radius: 18px;
  padding: 0 20px;
  font-size: 14px;
  margin-right: 8px;
  background: none;
  border: 2px solid #2F4858;
  color: #2F4858;
  cursor: pointer;
  font-family: 'hero-new', sans-serif;
  font-weight: 600;
  position: relative;
  margin-top: 12px;
  user-select: none;
  -webkit-user-select: none;
}

.segment button:hover {
  background-color: #EBF1F4;
}

.segment button.selected {
  background: #2F4858;
  color: white;
  cursor: inherit;
  font-weight: bold;
}

.segment button.vrh {
  color: #00929C;
  border-color: #00929C;
  padding-left: 30px;
}

.segment button.vrh.selected {
  color: white;
  background-color: #00929C;
}

.segment button.upt {
  color: #BF58BB;
  border-color: #BF58BB;
  padding-left: 30px;
}

.segment button.upt.selected {
  color: white;
  background-color: #BF58BB;
}

.segment button:last-of-type {
  margin-right: 0;
}

.segment button .bull {
  font-size: 28px;
  font-family: Arial, Helvetica, sans-serif;
  position: absolute;
  top: 1px;
  left: 12px;
}

.apexcharts-line-series.apexcharts-plot-series * {
  clip-path: none !important;
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  font-weight: 900;
  background: none;
  border: none;
  padding: 0px 10px;
  line-height: 24px;
  display: block;
  height: 24px;
  margin-top: 6px;
  margin-bottom: 2px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: 0;
  box-shadow: 0px 8px 20px rgba(0,0,0,0.2);
  background: white;
}

p.chart-sub {
  margin-top: 20px;
}
</style>
